import { useEffect } from 'react'
import { createBrowserHistory } from 'history';

const useScrollToTop = () => {
  const history = createBrowserHistory();

  useEffect(() => {
    if (history) {
      const unlisten = history.listen(() => {
        window.scrollTo(0, 0)
      })

      return () => {
        unlisten()
      }
    }
  }, [history])

  return null
}

export { useScrollToTop }
